import enumTypes from 'constants/enumTypes';
import {
  AllDeviceTypes, DeviceTypes, MessageCategories, LimitationTypes, CampaignV2SportEventTypes, CashbackTransferTypes, PlayerStatuses, SelfExclusionPeriods,
} from 'constants/enumTypes1';

const playerActions = [
  enumTypes.playerActions.BlockSportsbook,
  enumTypes.playerActions.UnblockSportsbook,
  enumTypes.playerActions.BlockCasino,
  enumTypes.playerActions.UnblockCasino,
  enumTypes.playerActions.BlockWithdrawals,
  enumTypes.playerActions.UnblockWithdrawals,
  enumTypes.playerActions.BlockDeposits,
  enumTypes.playerActions.UnblockDeposits,
  enumTypes.playerActions.BlockMessages,
  enumTypes.playerActions.UnblockMessages,
  enumTypes.playerActions.BlockAccount,
  enumTypes.playerActions.UnblockAccount,
  enumTypes.playerActions.BlockUnverify,
  enumTypes.playerActions.UnblockUnverify,
  enumTypes.playerActions.Unblock,
  enumTypes.playerActions.MarkAttention,
  enumTypes.playerActions.RemoveAttention,
  enumTypes.playerActions.Unlock,
  enumTypes.playerActions.AccountClosure,
  enumTypes.playerActions.Inactive,
  enumTypes.playerActions.Activate,
  enumTypes.playerActions.Lock,
  enumTypes.playerActions.Blacklist,
  enumTypes.playerActions.Whitelist,
  enumTypes.playerActions.VerifyEmail,
  enumTypes.playerActions.UnVerifyEmail,
  enumTypes.playerActions.VerifyIdentity,
  enumTypes.playerActions.UnVerifyIdentity,
  enumTypes.playerActions.VerifyMobile,
  enumTypes.playerActions.UnVerifyMobile,
  enumTypes.playerActions.VerifyAddress,
  enumTypes.playerActions.UnVerifyAddress,
  enumTypes.playerActions.VerifyCitizenship,
  enumTypes.playerActions.UnVerifyCitizenship,
  enumTypes.playerActions.CompletePhysicalVerification,
  enumTypes.playerActions.IncompletePhysicalVerification,
  enumTypes.playerActions.DisableLogin2FA,
  enumTypes.playerActions.EnableLogin2FA,
  enumTypes.playerActions.SetOTP,
];

const cashbackTransferType = [CashbackTransferTypes.Manual, CashbackTransferTypes.Automatic];

const accountStatuses = [
  PlayerStatuses.Active,
  PlayerStatuses.BlockedForSport,
  PlayerStatuses.BlockedForCasino,
  PlayerStatuses.BlockedForWithdrawals,
  PlayerStatuses.BlockedForDeposits,
  PlayerStatuses.Blocked,
  PlayerStatuses.BlockedForUnverified,
];

const messageCategories = [
  MessageCategories.Promotion,
  MessageCategories.Newsletter,
  MessageCategories.Notification,
  MessageCategories.Bonus,
  MessageCategories.Other,
];

const allDeviceTypes = [
  AllDeviceTypes.Betshop,
  AllDeviceTypes.WebDesktop,
  AllDeviceTypes.WebMobile,
  AllDeviceTypes.Wap,
  AllDeviceTypes.Terminal,
  AllDeviceTypes.Ios,
  AllDeviceTypes.Android,
  AllDeviceTypes.POS,
  AllDeviceTypes.LiteBet,
  AllDeviceTypes.WebOldMobile,
  AllDeviceTypes.PwaApp,
  AllDeviceTypes.TV,
  AllDeviceTypes.Unknown,
];

const deviceTypes = [
  DeviceTypes.WebDesktop,
  DeviceTypes.WebMobile,
  DeviceTypes.Ios,
  DeviceTypes.Android,
  DeviceTypes.PwaApp,
  DeviceTypes.TV,
  DeviceTypes.Other,
];

const bonuses = [enumTypes.bonuses.Casino, enumTypes.bonuses.Spin, enumTypes.bonuses.Sport, enumTypes.bonuses.Special];

const bonusTypes = {
  [enumTypes.bonuses.Casino]: [enumTypes.allBonusTypes.FreeBet, enumTypes.allBonusTypes.WagerStandard, enumTypes.allBonusTypes.WagerReal],
  [enumTypes.bonuses.Spin]: [enumTypes.allBonusTypes.FreeSpin, enumTypes.allBonusTypes.FreeAmount],
  [enumTypes.bonuses.Sport]: [enumTypes.allBonusTypes.SportFreeBet, enumTypes.allBonusTypes.SportWagering, enumTypes.allBonusTypes.SportRealWagering],
  [enumTypes.bonuses.Special]: [enumTypes.allBonusTypes.RealMoney],
};

const campaignTriggerTypes = [
  enumTypes.campaignTriggerTypes.NoTrigger,
  enumTypes.campaignTriggerTypes.SignUp,
  enumTypes.campaignTriggerTypes.SignIn,
  enumTypes.campaignTriggerTypes.Verify,
  enumTypes.campaignTriggerTypes.Deposit,
];

const campaignV2TriggerTypes = [
  enumTypes.campaignV2TriggerTypes.NoTrigger,
  enumTypes.campaignV2TriggerTypes.Deposit,
  enumTypes.campaignV2TriggerTypes.Bet,
  enumTypes.campaignV2TriggerTypes.SignUp,
  enumTypes.campaignV2TriggerTypes.SignIn,
  enumTypes.campaignV2TriggerTypes.Verify,
  enumTypes.campaignV2TriggerTypes.GameLaunch,
  enumTypes.campaignV2TriggerTypes.Withdrawal,
  enumTypes.campaignV2TriggerTypes.AutoDepositActivation,
];

const campaignV2BonusFamilies = [
  enumTypes.campaignV2BonusFamilies.FreeBet,
  enumTypes.campaignV2BonusFamilies.Spin,
  enumTypes.campaignV2BonusFamilies.Combined,
  enumTypes.campaignV2BonusFamilies.Special,
];

const campaignV2Bonuses = {
  [enumTypes.campaignV2BonusFamilies.FreeBet]: [enumTypes.campaignV2Bonuses.FreeBetSport, enumTypes.campaignV2Bonuses.FreeBetCasino],
  [enumTypes.campaignV2BonusFamilies.Spin]: [enumTypes.campaignV2Bonuses.FreeGame],
  [enumTypes.campaignV2BonusFamilies.Special]: [enumTypes.campaignV2Bonuses.RealMoney],
  [enumTypes.campaignV2BonusFamilies.Combined]: [enumTypes.campaignV2Bonuses.WagerCombined],
};

const playerBlockActions = [
  enumTypes.playerBlockActions.SportBooks,
  enumTypes.playerBlockActions.Casino,
  enumTypes.playerBlockActions.Withdrawals,
  enumTypes.playerBlockActions.Deposit,
  enumTypes.playerBlockActions.Messages,
  enumTypes.playerBlockActions.Unverified,
];

const regulatoryPlayerLimitCategories = [
  enumTypes.regulatoryPlayerLimitCategories.DailyTimeLimit,
  enumTypes.regulatoryPlayerLimitCategories.WeeklyTimeLimit,
  enumTypes.regulatoryPlayerLimitCategories.MonthlyTimeLimit,
  enumTypes.regulatoryPlayerLimitCategories.DailyDepositLimit,
  enumTypes.regulatoryPlayerLimitCategories.WeeklyDepositLimit,
  enumTypes.regulatoryPlayerLimitCategories.MonthlyDepositLimit,
  enumTypes.regulatoryPlayerLimitCategories.DailyLossLimit,
  enumTypes.regulatoryPlayerLimitCategories.WeeklyLossLimit,
  enumTypes.regulatoryPlayerLimitCategories.MonthlyLossLimit,
  enumTypes.regulatoryPlayerLimitCategories.Other,
];

const realityCheckRepetitionPeriod = [
  enumTypes.realityCheckRepetitionPeriod.None,
  enumTypes.realityCheckRepetitionPeriod.Minutes10,
  enumTypes.realityCheckRepetitionPeriod.Minutes15,
  enumTypes.realityCheckRepetitionPeriod.Minutes20,
  enumTypes.realityCheckRepetitionPeriod.Minutes30,
  enumTypes.realityCheckRepetitionPeriod.Minutes40,
  enumTypes.realityCheckRepetitionPeriod.Minutes45,
  enumTypes.realityCheckRepetitionPeriod.Minutes50,
  enumTypes.realityCheckRepetitionPeriod.Hours1,
  enumTypes.realityCheckRepetitionPeriod.Hours2,
  enumTypes.realityCheckRepetitionPeriod.Hours3,
  enumTypes.realityCheckRepetitionPeriod.Hours4,
  enumTypes.realityCheckRepetitionPeriod.Hours5,
  enumTypes.realityCheckRepetitionPeriod.Hours6,
];

const campaignV2SportEventTypes = [CampaignV2SportEventTypes.All, CampaignV2SportEventTypes.PreMatch, CampaignV2SportEventTypes.Live];

const playerLimitsPeriods = [
  enumTypes.playerLimitsPeriods.Immediately,
  enumTypes.playerLimitsPeriods.Daily,
  enumTypes.playerLimitsPeriods.Weekly,
  enumTypes.playerLimitsPeriods.Monthly,
  enumTypes.playerLimitsPeriods.Custom,
];

const selfExclusionPeriods = [
  SelfExclusionPeriods.None,
  SelfExclusionPeriods.Week1,
  SelfExclusionPeriods.Months1,
  SelfExclusionPeriods.Months2,
  SelfExclusionPeriods.Months3,
  SelfExclusionPeriods.Months6,
  SelfExclusionPeriods.Months8,
  SelfExclusionPeriods.Year1,
  SelfExclusionPeriods.Years2,
  SelfExclusionPeriods.Years3,
  SelfExclusionPeriods.Years5,
  SelfExclusionPeriods.Indefinite,
];

const brandAutomationLimitChangeTypes = [
  LimitationTypes.Deposit,
  LimitationTypes.Bet,
  LimitationTypes.LossLimit,
  LimitationTypes.GameTimeLimit,
  LimitationTypes.NetDeposit,
];

export {
  playerActions,
  cashbackTransferType,
  accountStatuses,
  messageCategories,
  allDeviceTypes,
  deviceTypes,
  bonuses,
  bonusTypes,
  campaignTriggerTypes,
  campaignV2TriggerTypes,
  campaignV2BonusFamilies,
  campaignV2Bonuses,
  playerBlockActions,
  regulatoryPlayerLimitCategories,
  campaignV2SportEventTypes,
  playerLimitsPeriods,
  realityCheckRepetitionPeriod,
  selfExclusionPeriods,
  brandAutomationLimitChangeTypes,
};
